import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';

const Delete = () => {

    // deleteAccountBtn
    const [showShimmer, setShowShimmer] = useState(true);

    // const deleteAccountBtn = () => {
    //     setDeletePopupActive(true);
    //     setShowShimmer(true);
    // }

    const handleDeleteAccountPopupClose = () => {
        window.history.back();
        setShowShimmer(false);
    }

    const handleDeleteAccount = async () => {
        const phoneNumber = document.querySelector('.deleteAccountPopup input').value.trim();
    
        if (!phoneNumber) {
            toast.error('Please enter your phone number.');
            return;
        }
    
        const apiUrl = 'https://esightsolutions.in/neethusapp/action/delete_profile.php';
        const formData = new FormData();
        formData.append('phone_number', phoneNumber);
    
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                body: formData,
            });
    
            const result = await response.json();
            console.log('Result:', result);
            if (result.delete_status === 1) {
                toast.success('Your account has been successfully deleted.');
                setShowShimmer(false);
                window.history.back();
            } else {
                toast.error(result.message || 'Failed to delete account. Please try again.');
            }
        } catch (error) {
            toast.error('An error occurred. Please check your internet connection and try again.');
            console.error('Error:', error);
        }
    };

    return (
        <div className='deletePage'>
            <div><Toaster/></div>

            {showShimmer && <div className="shimmer"></div>}

            {/* delete account popup */}
            <div className="deleteAccountPopup">
                <div className="deleteAccountPopupMain">
                    <h3>Delete Account</h3>
                    <p>Are you sure you want to delete your account?</p>
                    <form action="">
                        <div className="formGroup">
                            <label htmlFor="">Phone</label>
                            <input type="number" />
                        </div>
                    </form>
                    <div className="deleteAccountPopupBtns">
                        <button className='cancelDeleteAccountPopup' onClick={handleDeleteAccountPopupClose}>Cancel</button>
                        <button className='submitDeleteAccountPopup' onClick={handleDeleteAccount}>Delete</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Delete;